module.exports = __webpack_public_path__ + "img/Store-Active-Light.517160d.svg";